<template>
    <OverlayLoader :isLoading="!productLoaded || !categoriesLoaded || !deliverytimesLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('clients.connections.products.edit')"
                />

                <p>{{ $translate.text('clients.connections.product') + ' - ' + product.name}}</p>

                <form @submit.prevent="submitForm" method="POST">

                    <YesNoInput
                        id="productShow"
                        :value="product.show_product ? 'yes' : 'no'"
                        name="productShow"
                        @change="product.show_product = $event === 'yes'"
                        :label="$translate.text('clients.connections.product.show')"
                    />

                    <div style="margin-top: 8px;" v-if="product.show_product">
                        <TextInput
                            id="productName"
                            :value="product.custom_name"
                            name="productName"
                            @change="product.custom_name = $event"
                            :label="$translate.text('clients.connections.product.name')"
                            :placeholder="product.original_name"
                        />

                        <Placeholder
                            v-if="product.custom_name !== null"
                            :placeholder="product.original_name"
                        />

                        <NumberInput
                            id="productPricing"
                            :value="product.custom_price"
                            name="productPricing"
                            @change="product.custom_price = $event"
                            @blur="product.custom_price = parseFloat($event).toFixed(2)"
                            :label="$translate.text('clients.connections.product.pricing')"
                            :step="`.01`"
                            :placeholder="product.original_price"
                            :tooltip="true"
                            :tooltip_text="$translate.text('clients.pricing.explanation')"
                        />

                        <Placeholder
                            v-if="product.custom_price !== null"
                            :placeholder="product.original_price"
                        />

                        <TextInput
                            id="productNumber"
                            :value="product.custom_unique_code"
                            name="productNumber"
                            @change="product.custom_unique_code = $event"
                            :label="$translate.text('clients.connections.product.number')"
                            :placeholder="product.original_unique_code"
                        />

                        <Placeholder
                            v-if="product.custom_unique_code !== null"
                            :placeholder="product.original_unique_code"
                        />

                        <Select
                            id="category"
                            :value="product.custom_category"
                            name="category"
                            @change="product.custom_category = $event"
                            :options="categoryOptions"
                            :label="$translate.text('general.category')"
                            :loading="!categoriesLoaded"
                            v-if="product.custom_category"
                        />

                        <Select
                            v-else
                            id="category"
                            :value="product.connection_category.webshop_id"
                            name="category"
                            @change="product.custom_category = $event"
                            :options="categoryOptions"
                            :label="$translate.text('general.category')"
                            :loading="!categoriesLoaded"
                        />

                        <Placeholder
                            v-if="product.custom_category !== null && product.custom_category != product.connection_category.webshop_id"
                            :placeholder="getCategoryPlaceholder()"
                        />

                        <!-- <MultiSelect
                            id="category"
                            :value="product.alt_custom_category"
                            name="category"
                            @change="product.alt_custom_category = parseInt($event,10)"
                            :options="categoryOptions"
                            :label="$translate.text('general.alternative.categories')"
                            :loading="!categoriesLoaded"
                        /> -->

                        <div class="form-group">
                            <label for="categories">{{ $translate.text('general.alternative.categories') }}
                                <i
                                    style="font-size: 14px;"
                                ></i>
                            </label>

                            <Multiselect
                                v-model="product.additional_categories"
                                :options="categoryOptions"
                                :multiple="true"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Pick some"
                                label="name"
                                track-by="name"
                                open-direction="bottom"
                                :class="'test'"
                            >
                                <!-- <template slot="selection" open-direction="bottom" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template> -->
                            </Multiselect>
                        </div>

                        <TextInput
                            id="productName"
                            :value="product.custom_meta_title"
                            name="productName"
                            @change="product.custom_meta_title = $event"
                            :label="$translate.text('clients.connections.product.meta_title')"
                            :placeholder="product.original_meta_title"
                        />

                        <Placeholder
                            v-if="product.custom_meta_title != null"
                            :placeholder="product.original_meta_title"
                        />

                        <TextInput
                            id="productName"
                            :value="product.custom_meta_description"
                            name="productName"
                            @change="product.custom_meta_description = $event"
                            :label="$translate.text('clients.connections.product.meta_description')"
                            :placeholder="product.original_meta_description"
                        />

                        <Placeholder
                            v-if="product.custom_meta_description != null"
                            :placeholder="product.original_meta_description"
                        />

                        <TextInput
                            id="productName"
                            :value="product.custom_meta_keywords"
                            name="productName"
                            @change="product.custom_meta_keywords = $event"
                            :label="$translate.text('clients.connections.product.meta_keywords')"
                            :placeholder="product.original_meta_keywords"
                        />

                        <Placeholder
                            v-if="product.custom_meta_keywords != null"
                            :placeholder="product.original_meta_keywords"
                        />

                        <h4>{{ t('clients.connections.stock.settings') }}</h4>

                        <TextInput
                            id="custom_restock_time"
                            :value="product.custom_restock_time"
                            name="custom_restock_time"
                            @change="product.custom_restock_time = $event"
                            :label="$translate.text('clients.connections.stock.restock_time')"
                            :placeholder="product.original_restock_time"
                        />

                        <Placeholder
                            v-if="product.custom_restock_time != null"
                            :placeholder="product.original_restock_time"
                        />

                        <YesNoInput
                            id="custom_clearance_sale"
                            :value="product.custom_clearance_sale !== null ? (product.custom_clearance_sale ? 'yes' : 'no') : (product.original_clearance_sale ? 'yes' : 'no')"
                            name="custom_clearance_sale"
                            @change="product.custom_clearance_sale = $event === 'yes'"
                            :label="$translate.text('clients.connections.stock.clearance_sale')"
                        />

                        <Placeholder
                            v-if="product.custom_clearance_sale !== null && product.custom_clearance_sale != product.original_clearance_sale"
                            :placeholder="product.original_clearance_sale ? $translate.text('general.yes') : $translate.text('general.no')"
                        />

                        <Select
                            v-if="deliverytimesLoaded"
                            id="custom_delivery_time"
                            :value="product.custom_delivery_time !== null ? product.custom_delivery_time : product.original_delivery_time"
                            name="stockDeliveryTime"
                            @change="product.custom_delivery_time = $event"
                            :options="deliverytimesSelectValues"
                            :label="$translate.text('clients.connections.stock.delivery_time')"
                        />

                        <Placeholder
                            v-if="product.custom_delivery_time !== null && product.custom_delivery_time != product.original_delivery_time"
                            :placeholder="getDeliverytimePlaceholder()"
                        />

                    </div>

                    <FormSubmit
                        :routeAfterCancelLink="{ name: 'Clients Connections Products', params: { id: this.$route.params.id } }"
                        :buttonLabel="submittingIsLoading ? $translate.text('clients.connections.product.saving') :  $translate.text('clients.connections.product.save')"
                        :disabled="submittingIsLoading"
                    />
                </form>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';
import Multiselect from 'vue-multiselect';

import handleError from '@/helpers/error';

import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import TextInput from '@/components/Inputs/TextInput';
import YesNoInput from '@/components/Inputs/YesNoInput';
import FormSubmit from '@/components/Forms/FormSubmit';
import NumberInput from '@/components/Inputs/NumberInput';
import Select from '@/components/Inputs/Select';

import Placeholder from '@/components/Inputs/Placeholder';

export default {
    name: 'EditProduct',

    components: {
        OverlayLoader,
        PageHeader,
        TextInput,
        YesNoInput,
        FormSubmit,
        NumberInput,
        Select,
        Placeholder,
        Multiselect,
    },

    data() {
        return {
            // Demo data objectje zodra de daadwerkelijke call binnen is deze verwerken.
            product: {},
            productLoaded: false,
            options: [
                { label: this.$translate.text('general.yes'), value: 1 },
                { label: this.$translate.text('general.no'), value: 0 },
            ],
            submittingIsLoading: false,

            categories: {},
            categoriesLoaded: false,

            categoryOptions: [],

            deliverytimes: [],
            deliverytimesLoaded: false,
        };
    },

    created() {
        this.getProduct();
        this.getDeliverytimes();
    },

    methods: {
        submitForm() {
            const id = this.$route.params.id;
            const productId = this.$route.params.productId;

            this.submittingIsLoading = true;
            const altCategories = [];
            this.product.additional_categories.forEach(category => {
                altCategories.push(category.shop_category_id);
            });


            const submitData = {
                show_product: this.product.show_product,
                custom_price: this.product.custom_price,
                custom_name: this.product.custom_name,
                custom_unique_code: this.product.custom_unique_code,
                custom_category: this.product.custom_category,
                additional_categories: altCategories,
                custom_meta_title: this.product.custom_meta_title,
                custom_meta_description: this.product.custom_meta_description,
                custom_meta_keywords: this.product.custom_meta_keywords,
                custom_restock_time: this.product.custom_restock_time,
                custom_clearance_sale: this.product.custom_clearance_sale,
                custom_delivery_time: this.product.custom_delivery_time,
            };

            this.API.clients.connections.productPatch(id, productId, submitData)
                .then(() => {
                    this.submittingIsLoading = false;

                    swal({
                        title: this.$translate.text('alert.success'),
                        text: this.$translate.text('alert.success.message.saved'),
                    }).then(() => {
                        this.$router.push({ name: 'Clients Connections Products', params: { id: this.$route.params.id } });
                    });
                })
                .catch((error) => {
                    this.submittingIsLoading = false;
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getProduct() {
            this.API.clients.connections.productsShow(this.$route.params.id, this.$route.params.productId)
                .then((response) => {
                    this.product = response.data.data;
                    this.productLoaded = true;
                    this.getCombinedCategories();
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getDeliverytimes() {
            this.API.clients.connections.deliverytimes(this.$route.params.id)
                .then(response => {
                    this.deliverytimes = response.data.data;
                    this.deliverytimesLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCombinedCategories() {
            this.API.clients.connections.categories.getItemsFromWebshop(this.$route.params.id)
                .then(response => {
                    this.categories = response.data;
                    this.categoriesLoaded = true;
                    this.getCategoryOptions(this.categories);
                    this.renameSubCategories();
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCategoryOptions(list, prefix = null) {
            list.forEach(item => {
                const data = {};
                if (prefix !== null) {
                    data.name = `${prefix} - ${item.name}`;
                    data.label = `${prefix} - ${item.name}`;
                    data.value = item.id;
                    data.shop_category_id = item.id;
                } else {
                    data.name = item.name;
                    data.label = item.name;
                    data.value = item.id;
                    data.shop_category_id = item.id;
                }
                this.categoryOptions.push(data);

                if (item.children !== null) {
                    this.getCategoryOptions(item.children, data.name);
                }
            });
        },

        renameSubCategories() {
            this.product.additional_categories.forEach(subCategory => {
                subCategory.name = this.categoryOptions.find(categoryOption => categoryOption.shop_category_id === subCategory.shop_category_id).name;
            });
        },

        getCategoryPlaceholder() {
            let text = '';
            this.categoryOptions.forEach(item => {
                if (`${item.value}` === this.product.original_category) {
                    text = item.name;
                }
            });
            return text;
        },

        getDeliverytimePlaceholder() {
            let text = '';
            this.deliverytimes.forEach(item => {
                if (`${item.id}` === this.product.original_delivery_time) {
                    text = item.name;
                }
            });
            return text;
        },
    },

    computed: {
        deliverytimesSelectValues() {
            const values = [{ label: this.$translate.text('general.select_option'), value: null, disabled: true }];

            this.deliverytimes.forEach(deliverytime => {
                values.push({
                    value: deliverytime.id,
                    label: deliverytime.name,
                });
            });

            return values;
        },
    },
};
</script>
<style lang="scss" scoped>
form {
    padding-top: 32px;

    .form-group + .form-group {
        margin-top: 8px;
    }

    .form-submit {
        margin-top: 8px;
    }
}
.form-group {
   display: flex;
   align-items: center;

    label {
        color: $black;
        flex: 2;
    }

    .multiselect {
         -webkit-box-flex: 6;
    -ms-flex: 6;
    flex: 6;
    // height: 42px;
    font-size: 16px;
    border: 0;
    background-color: white;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
    padding: 0px 16px;
    }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css">


</style>
